<!-- 聊天 -->
<template>
  <div id="chat" class="chat" @click="hideHistoryList">
    <!--未接入时的遮罩-->
    <div class="cover" @click="cantWriteMsg" v-if="!nowKhMsg.uId">
      <p>
        <img src="../../assets/images/logo-gray.png" alt />
      </p>
      <p>当前未接入客户</p>
    </div>
    <!--头部信息区-->
    <div class="chat-title">
      <i class="el-icon-service chat-title-icon"></i>
      <div class="chat-title-main">
        <p v-if="chatype == 1">
          当前客户：
          <span class="color-theme">{{nowKhMsg.uName}}</span>
        </p>
        <p v-else>
          正在给
          <span class="color-theme">{{nowKhMsg.uName}}</span>留言
        </p>&nbsp;&nbsp;&nbsp;&nbsp;
        <p>
          <!-- 访问：
                    <span class="color-theme">--</span>次&nbsp;&nbsp;&nbsp;&nbsp;
                    对话：
                    <span class="color-theme">--</span>次&nbsp;&nbsp;&nbsp;&nbsp;
                    IP：
                    <span
                        class="color-theme"
          >{{nowKhMsg.ip}}</span>&nbsp;&nbsp;&nbsp;&nbsp;-->
          来源：
          <!-- <span class="color-theme">{{nowKhMsg.referer|refererHandle}}</span> -->
          <span class="color-theme">{{nowKhMsg.refererName}}</span>
        </p>
      </div>
    </div>
    <!-- 聊天框 -->
    <div class="chat-content" id="chatContent">
      <div class="no-more-chat" v-show="noMoreChat">--已无更多消息--</div>
      <div class="show-more-chat" @click="loadHistoryChat" v-show="!noMoreChat">
        <i class="el-icon-time"></i>
        &nbsp;查看更多消息
      </div>
      <div v-for="(item,index) in chatRecord" :key="item.id">
        <!-- 时间  -->
        <div class="chat-time" v-if="item.type== -1">{{item.content}}</div>
        <!-- 客服文字 -->
        <div v-if="item.type == 1" class="iSay cha-content">
          <div>
            <span class="have-read" v-if="item.isRead">已读</span>
            <span class="no-read" v-else>未读</span>
          </div>
          <span class="myContent" v-html="item.content"></span>
          <div class="userHeader">
            <img src="../../assets/images/kf-head.png" alt class="my-head" />
          </div>
        </div>
        <!-- 客服图片 -->
        <div v-else-if="item.type==2" class="iSay iSayImage cha-content">
          <div>
            <span class="have-read" v-if="item.isRead">已读</span>
            <span class="no-read" v-else>未读</span>
          </div>
          <div class="image-ctn">
            <i class="el-icon-loading" v-show="item.showLoading"></i>
            <img
              class="chat-image"
              :src="downUrl + item.content"
              v-if="item.isHistory"
              @click="showBig($event)"
            />
            <img class="chat-image" :src="item.content" v-else @click="showBig($event)" />
          </div>
          <div class="userHeader">
            <img src="../../assets/images/kf-head.png" alt class="my-head" />
          </div>
        </div>
        <!-- 客服推送门店 -->
        <div v-else-if="item.type==3" class="iSay iPushShop cha-content">
          <div>
            <span class="have-read" v-if="item.isRead">已读</span>
            <span class="no-read" v-else>未读</span>
          </div>
          <div class="pushShopCtn">
            <el-card class="box-card order-item-ctn">
              <div slot="header">
                <span>{{item.content.Cn}}</span>
              </div>
              <div class="text item order-item">
                <img :src="downUrl + item.content.LogoUrl" alt class="order-cover" />
              </div>
            </el-card>
          </div>
          <div class="userHeader">
            <img src="../../assets/images/kf-head.png" alt class="my-head" />
          </div>
        </div>
        <!-- 客服推送汽配件 -->
        <div v-else-if="item.type==4" class="iSay iPushShop cha-content">
          <div>
            <span class="have-read" v-if="item.isRead">已读</span>
            <span class="no-read" v-else>未读</span>
          </div>
          <div class="pushShopCtn">
            <el-card class="box-card order-item-ctn">
              <div slot="header">
                <span>{{item.content.Cn}}</span>
              </div>
              <div class="text item order-item">
                <img
                  :src="downUrl+item.content.PublicUrl"
                  alt
                  class="order-cover"
                  :onerror="defaultImg"
                />
                <div>
                  <div class="order-msg">编码：{{item.content.Code}}</div>
                </div>
              </div>
            </el-card>
          </div>
          <div class="userHeader">
            <img src="../../assets/images/kf-head.png" alt class="my-head" />
          </div>
        </div>
        <!-- 客服推送临时商品 -->
        <div v-else-if="item.type==10" class="iSay iPushShop cha-content">
          <div>
            <span class="have-read" v-if="item.isRead">已读</span>
            <span class="no-read" v-else>未读</span>
          </div>
          <div class="pushShopCtn">
            <el-card class="box-card order-item-ctn">
              <div slot="header">
                <span>{{item.content.GoodName}}</span>
              </div>
              <div class="text item order-item">
                <img
                  :src="downUrl+item.content.MainImg"
                  alt
                  class="order-cover"
                  :onerror="defaultImg"
                />
                <div>
                  <div class="order-msg">编码：{{item.content.GoodCode}}</div>
                  <div class="order-msg">价格：{{item.content.MarketPrice}}</div>
                  <div class="order-msg">库存：{{item.content.Inventory}}</div>
                </div>
              </div>
            </el-card>
          </div>
          <div class="userHeader">
            <img src="../../assets/images/kf-head.png" alt class="my-head" />
          </div>
        </div>
        <!-- 客服推送商城商品 -->
        <div v-else-if="item.type==11" class="iSay iPushShop cha-content">
          <div>
            <span class="have-read" v-if="item.isRead">已读</span>
            <span class="no-read" v-else>未读</span>
          </div>
          <div class="pushShopCtn" @click="gotoGoodsDetails(item.content.Id)">
            <el-card class="box-card order-item-ctn">
              <div slot="header">
                <span>{{item.content.Name}}</span>
              </div>
              <div class="text item order-item">
                <img
                  :src="downUrl+item.content.ShowImg"
                  alt
                  class="order-cover"
                  :onerror="defaultImg"
                />
                <div>
                  <div class="order-msg">价格：{{item.content.ShopPrice}}</div>
                </div>
              </div>
            </el-card>
          </div>
          <div class="userHeader">
            <img src="../../assets/images/kf-head.png" alt class="my-head" />
          </div>
        </div>
        <!-- 客户文字 -->
        <div v-else-if="item.type== 5" class="otherSay cha-content">
          <div class="userHeader">
            <img :src="nowKhMsg.avatarUrl" alt class="my-head" />
          </div>
          <span class="otherContent" v-html="item.content"></span>
        </div>
        <!-- 客户图片 -->
        <div v-else-if="item.type== 6" class="otherSay cha-content">
          <div class="userHeader">
            <img :src="nowKhMsg.avatarUrl" alt class="my-head" />
          </div>
          <div class="image-ctn">
            <img class="chat-image" :src="downUrl + item.content" alt @click="showBig($event)" />
          </div>
        </div>
        <!-- 客户语音 -->
        <div v-else-if="item.type== 7" class="otherSay cha-content">
          <div class="userHeader">
            <img :src="nowKhMsg.avatarUrl" alt class="my-head" />
          </div>
          <span class="otherContent voice-ctn" @click="playVoice(item,index)">
            <img
              src="../../assets/images/voice-right.gif"
              class="chat-voice-icon"
              v-if="item.playing"
            />
            <img src="../../assets/images/voice-right.png" class="chat-voice-icon" v-else />
          </span>
        </div>
        <!-- 客户询问商品 -->
        <div v-else-if="item.type== 8" class="otherSay iPushShop cha-content">
          <div class="userHeader">
            <img :src="nowKhMsg.avatarUrl" alt class="my-head" />
          </div>
          <div class="pushShopCtn">
            <el-card class="box-card order-item-ctn">
              <div slot="header">
                <span>{{item.content.Cn}}</span>
              </div>
              <div class="text item order-item">
                <img :src="downUrl+item.content.PublicUrl" alt class="order-cover" />
                <div>
                  <div class="order-msg">编码：{{item.content.Code}}</div>
                </div>
              </div>
            </el-card>
          </div>
        </div>
        <!-- 客户询问订单 -->
        <div v-else-if="item.type== 9" class="otherSay iPushShop cha-content">
          <div class="userHeader">
            <img :src="nowKhMsg.avatarUrl" alt class="my-head" />
          </div>
          <div class="pushShopCtn">
            <el-card class="box-card order-item-ctn">
              <div class="order-num">
                <div style="display: flex;justify-content: space-between">
                  <span>订单号：{{item.content.OrderCode}}</span>
                  <span class="open-btn" v-if="item.content.Detail.length > 1">
                    <label v-if="item.open" @click="toggleOpen(1,index)">收起</label>
                    <label v-else @click="toggleOpen(2,index)">展开</label>
                  </span>
                </div>
                <div>{{item.content.CreateTime}}</div>
              </div>
              <div class="goods-ctn" :class="{'close-sate':!item.open}">
                <div class="text item order-item" v-for="i in item.content.Detail" :key="i.GoodId">
                  <img :src="downUrl+i.MainImg" :onerror="defaultImg" class="order-cover" />
                  <div>
                    <div class="order-name">{{i.GoodName}}</div>
                    <div class="order-msg">编码：{{i.GoodCode}}</div>
                  </div>
                </div>
              </div>
              <div class="order-price">
                <div>订单金额：￥{{item.content.SurplusMoney}}</div>
                <div class="order-state">{{item.content.StateName}}</div>
              </div>
            </el-card>
          </div>
        </div>
        <!-- 客户发送定位 -->
        <div v-else-if="item.type== 12" class="otherSay iPushShop cha-content">
          <div class="userHeader">
            <img :src="nowKhMsg.avatarUrl" alt class="my-head" />
          </div>
          <div class="pushShopCtn" @click="showMap(1,item.content)">
            <el-card class="box-card">
              <div slot="header" style="display: flex;justify-content: space-between;">
                <span>{{item.content.name}}</span>
                <span
                  style="color:#409eff;cursor:pointer"
                  @click.stop="copyAddress(item.content.address)"
                >复制地址</span>
              </div>
              <div>
                <div>
                  <img src="../../assets/images/map.png" style="width: 100%;height: auto" />
                </div>
                <div>{{item.content.address}}</div>
              </div>
            </el-card>
          </div>
        </div>
        <!-- 客服推送位置 -->
        <div v-else-if="item.type==13" class="iSay iPushShop cha-content">
          <div>
            <span class="have-read" v-if="item.isRead">已读</span>
            <span class="no-read" v-else>未读</span>
          </div>
          <div class="pushShopCtn" @click="showMap(1,item.content)">
            <el-card class="box-card">
              <div slot="header">
                <span>{{item.content.name}}</span>
              </div>
              <div>
                <div>
                  <img src="../../assets/images/map.png" style="width: 100%;height: auto" />
                </div>
                <div>{{item.content.address}}</div>
              </div>
            </el-card>
          </div>
          <div class="userHeader">
            <img src="../../assets/images/kf-head.png" alt class="my-head" />
          </div>
        </div>
        <!-- 客服推送车辆认证link -->
        <div v-else-if="item.type==14" class="iSay iPushShop cha-content">
          <div>
            <span class="have-read" v-if="item.isRead">已读</span>
            <span class="no-read" v-else>未读</span>
          </div>
          <div class="pushShopCtn" @click="showMap(1,item.content)">
            <el-card class="box-card">
              <div slot="header">
                <span>认证车辆</span>
              </div>
              <div>
                <div>
                  <img src="../../assets/images/rz-icon.png" alt style="width: 50px;height: 50px" />
                </div>
                <div>点击前往车辆认证</div>
              </div>
            </el-card>
          </div>
          <div class="userHeader">
            <img src="../../assets/images/kf-head.png" alt class="my-head" />
          </div>
        </div>
        <!-- 客服推送上门费用 -->
        <div v-else-if="item.type==15&&item.content.RName" class="iSay iPushShop cha-content">
          <div>
            <span class="have-read" v-if="item.isRead">已读</span>
            <span class="no-read" v-else>未读</span>
          </div>
          <div class="pushShopCtn">
            <el-card class="box-card">
              <div slot="header">
                <span>{{item.content.RName}}</span>
              </div>
              <div>
                <div>服务费：￥{{item.content.SurplusMoney}}</div>
              </div>
            </el-card>
          </div>
          <div class="userHeader">
            <img src="../../assets/images/kf-head.png" alt class="my-head" />
          </div>
        </div>
        <!--客户确认上门费用-->
        <div v-else-if="item.type==15&&!item.content.RName" class="otherSay cha-content">
          <div class="userHeader">
            <img :src="nowKhMsg.avatarUrl" alt class="my-head" />
          </div>
          <span class="otherContent" v-html="item.content"></span>
        </div>
        <!--视频-->
        <div
          v-else-if="item.type==99"
          class="cha-content"
          v-bind:class="{'iSay':item.IsReciever,'otherSay':!item.IsReciever}"
        >
          <div v-if="item.IsReciever">
            <span class="have-read" v-if="item.isRead">已读</span>
            <span class="no-read" v-else>未读</span>
          </div>
          <div class="userHeader" v-else>
            <img :src="nowKhMsg.avatarUrl" alt class="my-head" />
          </div>
          <div>
            <video class="chat-image" :src="downUrl + item.content" controls width="300px" />
          </div>
        </div>
      </div>
    </div>
    <!--输入操作区-->
    <div class="chat-input">
      <div class="chat-options">
        <img src="../../assets/images/zhuanj.png" alt title="转接客服" @click="transfer" />
        <img src="../../assets/images/pingb.png" alt title="屏蔽访客" @click="showShield" />
        <img src="../../assets/images/biaoq.png" alt title="表情" @click.stop="showEmotion" />
        <img src="../../assets/images/pic.png" alt title="发送图片" @click="chooseImg" />
        <img
          src="../../assets/images/location2.png"
          alt
          title="发送位置"
          @click="showMap(2)"
          v-show="nowKhMsg.uType != 0"
        />
        <img
          src="../../assets/images/rz-icon.png"
          alt
          title="车辆认证"
          @click="pushRz()"
          v-show="nowKhMsg.uType == 0"
        />
        <form action id="uploadForm">
          <input
            type="file"
            accept="image/*"
            style="display: none"
            id="chooseImgBtn"
            @change="uploadImg"
          />
        </form>
        <img
          src="../../assets/images/push.png"
          alt
          title="推送门店"
          @click="showPush"
          v-show="nowKhMsg.uType == 0"
        />
        <img
          src="../../assets/images/ico_rr.png"
          alt
          title="预约维修"
          @click="createRReservations()"
          v-show="nowKhMsg.uType == 0"
        />
        <img
          src="../../assets/images/fee.png"
          alt
          title="推送服务费"
          @click="showFeeList"
          v-show="nowKhMsg.uType == 0"
        />
      </div>
      <div>
        <!-- 输入框 -->
        <textarea class="input-box" id="input-box" @keyup.enter="send" v-model.trim="inputValue"></textarea>
      </div>
      <div class="send-ctn">
        <el-button size="mini" @click="stopChat">结束对话</el-button>
        <el-button size="mini" type="primary" @click="send">发送</el-button>
      </div>
    </div>
    <!--客服转接弹出窗-->
    <el-dialog title="客服转接" :visible.sync="showTransfer" width="66%">
      <div class="transfer-content">
        <div class="transfer-search">
          <el-input
            placeholder="回车搜索客服"
            class="search-input"
            v-model="searchKfKey"
            @keyup.enter.native="searchOtherServes()"
          ></el-input>
        </div>
        <div class="main-ctn">
          <div class="kf-list-ctn">
            <div class="main-ctn-title">客服列表</div>
            <div class="kf-list">
              <div
                class="kf-item"
                v-for="(item,index) in kfList"
                :key="item.Id"
                @click="chooseKf(item,index)"
                :class="{'kf-active':index == kfListActive}"
              >
                <img src="../../assets/images/man.png" alt v-if="item.Sex == 1" />
                <img src="../../assets/images/wuman.png" alt v-else />
                <span class="kf-name">{{item.Name}}</span>
                <span class="kf-remark">{{item.TypeName}}</span>
              </div>
            </div>
          </div>
          <div class="trans-reason-ctn">
            <div class="main-ctn-title is-required">事由</div>
            <div class="trans-reason">
              <textarea v-model.trim="transData.Reason"></textarea>
            </div>
            <div class="main-ctn-title">紧急程度</div>
            <div>
              <el-select v-model="transData.EmergencyDegree" placeholder="请选择" style="width: 100%">
                <el-option label="一般" value="0"></el-option>
              </el-select>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" @click="transferHandle(0)">取 消</el-button>
        <el-button size="medium" type="primary" @click="transferHandle(1)">确 定</el-button>
      </span>
    </el-dialog>
    <!--推送门店弹出窗-->
    <el-dialog title="推送门店" :visible.sync="showPushShop" width="66%">
      <div>
        <div class="transfer-search">
          <el-input
            placeholder="搜索门店"
            class="search-input"
            v-model.trim="shopSearchData.key"
            @keyup.native.enter="showPush"
          ></el-input>
        </div>
        <div class="main-ctn">
          <div class="main-ctn-title">门店列表</div>
          <div class="kf-list">
            <template>
              <el-table @row-click="pushShop" :data="mDList" border style="width: 100%">
                <el-table-column prop="Cn" label="门店名称"></el-table-column>
                <el-table-column prop="Abbr" label="地址"></el-table-column>
              </el-table>
            </template>
          </div>
        </div>
      </div>
    </el-dialog>
    <!--屏蔽访客弹窗-->
    <el-dialog title="屏蔽访客" :before-close="resetShield" :visible.sync="shieldVisible" width="66%">
      <div class="shield-dialog-content">
        <el-form label-width="100px">
          <el-form-item label="是否永久封锁">
            <el-radio v-model="shieldData.IsPerpetualBlock" :label="boolTrue">是</el-radio>
            <el-radio v-model="shieldData.IsPerpetualBlock" :label="boolFalse">否</el-radio>
          </el-form-item>
          <el-form-item label="封锁时间" v-show="!shieldData.IsPerpetualBlock">
            <el-input-number
              v-model="shieldDays"
              :min="1"
              size="mini"
              @change="shieldDaysChange(shieldDays)"
            ></el-input-number>&nbsp;&nbsp;&nbsp;&nbsp;天
          </el-form-item>
          <el-form-item label="封锁原因">
            <el-input
              type="textarea"
              placeholder="请输入封锁原因"
              v-model.trim="shieldData.BlockReason"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="shieldVisible = false">取 消</el-button>
        <el-button type="primary" @click="shield">确 定</el-button>
      </span>
    </el-dialog>
    <!--显示地图-->
    <el-dialog title="位置" :before-close="clearMap" :visible.sync="mapVisible" width="800px">
      <div class="shield-dialog-content" v-if="mapVisible">
        <qqmap
          :locationMsg="locationMsg"
          @clearMap="clearMap"
          @sendLocation="sendLocation"
          @createRReservations="createRReservations"
        ></qqmap>
      </div>
    </el-dialog>
    <!-- 服务费 -->
    <el-dialog title="服务订单" :visible.sync="feeVisible" width="1000px">
      <div class="shield-dialog-content" v-if="feeVisible">
        <fee :uid="nowKhMsg.uId" @closeFee="clearFee"></fee>
      </div>
    </el-dialog>
    <!--表情包-->
    <div class="emoji" id="emoji" v-show="isEmotionShow">
      <span v-for="item in emoji" @click="change(item)" :key="item" class="emoji-item">{{item}}</span>
    </div>
    <!--查看大图-->
    <bigImage :src="showBigSrc" :show="showBigState" @hide="showBigState = false"></bigImage>
  </div>
</template>
<script>
import uploadFile from "../../assets/js/uploadFile";
import emoji from "../../../public/libs/emoji/emoji";
import bigImage from "@/components/workbench/bigImage.vue";
import qqmap from "@/components/workbench/map.vue";
import fee from "@/components/workbench/fee.vue";
export default {
  name: "chat",
  components: {
    bigImage,
    qqmap,
    fee
  },
  data() {
    return {
      audioContext: null,
      feeVisible: false, // 显示服务费列表
      locationMsg: null, // 当前点击的用户发来的定位信息
      mapVisible: false, // 显示地图
      showBigSrc: "", //显示大图路径
      showBigState: false, // 是否显示大图
      searchKfKey: "",
      noMoreChat: false, // 为true时已经没有更多历史消息了
      historyPage: 1, // 当前显示历史的第几页
      boolTrue: true,
      boolFalse: false,
      shieldVisible: false, //显示屏蔽访客弹窗
      userMsg: "",
      chatype: 1, // 聊天类型 1 正常交谈   2 留言
      nowKhMsg: {}, // 当前顾客的信息
      mDList: [], // 客服要推送的门店列表
      nowLpLoadImgIndex: "", // 正在上传的图片索引
      upUrl: this.$util.QN_UPLOAD_URL, // 上传多媒体地址
      downUrl: this.$util.QN_URL_BASE, // 下载
      defaultImg: 'this.src="' + this.$util.DEFAULT_IMAGE + '"',
      chatTimestamp: null, // 最近一次接收或发送消息的时间戳
      connSid: "",
      voiceList: {}, // 聊天语音列表
      chatType: 1, // 1为文字  2为语音
      inputValue: "", // 发送内容
      chatRecord: [], // 聊天信息
      prevPlayIndex: "", // 上一个播放的语音在列表中的下标
      isEmotionShow: false,
      emoji: emoji.emoji,
      showTransfer: false, // 是否显示客服转接
      showPushShop: false, // 显示推送门店
      shopSearchData: {
        // 推送门店搜索框的值
        key: "",
        page: 1,
        limit: 10
      },
      kfList: [], // 转接客服列表
      kfListActive: -1, // 选中的客服索引
      transData: {
        UId: "",
        UName: "",
        SId: "",
        ToSId: "",
        Reason: "",
        EmergencyDegree: "0",
        UserType: 0,
        SessionId: "",
        Ip: "",
        Referer: 0,
        SessionType: 0
      },
      transKfMsg: {}, // 转接客服选中的客服的信息
      shieldDays: 1, // 封锁天数
      shieldData: {
        //  屏蔽访客相关信息
        UType: "",
        UId: "",
        IsPerpetualBlock: false, //是否永久封锁
        BlockReason: "", // 封锁原因
        UnBlockTime: ""
      }
    };
  },
  mounted() {
    let that = this;
    this.audioContext = document.createElement("AUDIO");
    this.audioContext.addEventListener(
      "ended",
      () => {
        let _chatRecord = this.chatRecord;
        for (let i = 0; i < _chatRecord.length; i++) {
          if (_chatRecord[i].type == 7) {
            _chatRecord[i].playing = false;
          }
        }
      },
      false
    );
    window.onclick = function() {
      that.isEmotionShow = false;
    };
  },
  computed: {
    getRepairFeeMsg() {
      return this.$store.getters.getRepairFeeMsg;
    },
    getPushGoodMsg() {
      return this.$store.getters.getPushGoodMsg;
    },
    getPushShopGoodMsg() {
      return this.$store.getters.getPushShopGoodMsg;
    },
    // socket 状态
    socketStatus() {
      return this.$store.state.connectState;
    },
    getCurrChatClient() {
      return this.$store.getters.getCurrChatClient;
    }
  },
  filters: {
    refererHandle(val) {
      if (val == 0) {
        return "小程序-车主";
      } else if (val == 1) {
        return "小程序-汽修厂";
      } else if (val == 2) {
        return "小程序-汽配厂";
      } else if (val == 3) {
        return "企业客户端-汽修厂";
      } else if (val == 4) {
        return "商城小程序";
      }
    }
  },
  watch: {
    // 上门服务费信息
    getRepairFeeMsg(value) {
      let _chatRecord = this.chatRecord;
      let _data = {
        content: value,
        type: 15,
        id: Math.random(),
        isRead: false
      };
      this.showTime();
      if (this.chatype == 1) {
        _chatRecord.push(_data);
        this.$util.sendSocket({
          cId: this.nowKhMsg.uId,
          SessionId: this.nowKhMsg.sessionId,
          contentType: 10,
          content: value,
          ObjectId: value.RRId
        });
      } else {
        _chatRecord.push(_data);
        this.$util.sendLeaveMeg({
          cId: this.nowKhMsg.uId,
          SessionId: this.nowKhMsg.sessionId,
          contentType: 10,
          content: value
        });
      }
    },
    socketStatus(value) {
      // 客服主动下线,重新加载列表
      if (value == 0) {
        this.nowKhMsg = {};
        this.noMoreChat = false; // 为true时已经没有更多历史消息了
        this.historyPage = 1; // 当前显示历史的第几页
      }
    },
    // 拿到推送临时商品或配件的信息
    getPushGoodMsg(value) {
      let _nowKhMsg = value.customerMsg;
      let _goodMsg = value.goodMsg;
      let _chatRecord = this.chatRecord;
      if (this.nowKhMsg.uId != _nowKhMsg.uId) {
        this.nowKhMsg = _nowKhMsg;
        this.chatRecord = [];
      }
      let _data = {
        content: _goodMsg,
        type: _goodMsg.GoodName ? 10 : 4,
        id: Math.random(),
        isRead: false
      };
      this.showTime();
      if (this.chatype == 1) {
        this.$util.sendSocket(
          {
            cId: _nowKhMsg.uId,
            SessionId: this.nowKhMsg.sessionId,
            contentType: _goodMsg.GoodName ? 5 : 2, // 2 是汽配件 5 是临时商品
            content: _goodMsg,
            ObjectId: _goodMsg.Id
          },
          function(res) {
            _data.id = res.data;
            _chatRecord.push(_data);
          }
        );
      } else {
        this.$util.sendLeaveMeg(
          {
            cId: _nowKhMsg.uId,
            SessionId: this.nowKhMsg.sessionId,
            contentType: _goodMsg.GoodName ? 5 : 2, // 2 是汽配件 5 是临时商品
            content: _goodMsg,
            ObjectId: _goodMsg.Id
          },
          function(res) {
            _data.id = res.data;
            _chatRecord.push(_data);
          }
        );
      }
    },
    // 拿到推送商城商品
    getPushShopGoodMsg(value) {
      let _nowKhMsg = value.customerMsg;
      let _goodMsg = value.goodMsg;
      let _chatRecord = this.chatRecord;
      if (this.nowKhMsg.uId != _nowKhMsg.uId) {
        this.nowKhMsg = _nowKhMsg;
        this.chatRecord = [];
      }
      let _data = {
        content: _goodMsg,
        type: 11,
        id: Math.random(),
        isRead: false
      };
      this.showTime();
      if (this.chatype == 1) {
        this.$util.sendSocket(
          {
            cId: _nowKhMsg.uId,
            SessionId: this.nowKhMsg.sessionId,
            contentType: 6,
            content: _goodMsg,
            ObjectId: _goodMsg.Id
          },
          function(res) {
            _data.id = res.data;
            _chatRecord.push(_data);
          }
        );
      } else {
        this.$util.sendLeaveMeg(
          {
            cId: _nowKhMsg.uId,
            SessionId: this.nowKhMsg.sessionId,
            contentType: 6,
            content: _goodMsg,
            ObjectId: _goodMsg.Id
          },
          function(res) {
            _data.id = res.data;
            _chatRecord.push(_data);
          }
        );
      }
    },
    //监听当前聊天客户
    getCurrChatClient(value) {
      //离线，接收对话时清空当前聊天客户
      if (JSON.stringify(value) == "{}") {
        this.nowKhMsg = {};
        return;
      }
      if (this.nowKhMsg.uId == value.uId) {
        return;
      }
      this.chatype = value.sessionId ? 1 : 2;
      this.nowKhMsg = value;
      this.chatRecord = [];
      this.historyPage = 1;
      this.noMoreChat = false;
      this.GetNoRead();
    }
  },
  methods: {
    // 点击聊天窗隐藏客户访问历史模块
    hideHistoryList() {
      this.$emit("hideHistory");
    },
    // 打开服务费弹窗
    showFeeList() {
      this.feeVisible = true;
    },
    // 关闭服务费弹窗
    clearFee() {
      this.feeVisible = false;
    },
    // 复制
    copyAddress(content) {
      let val = content;
      document.addEventListener("copy", save); // 监听浏览器copy事件
      document.execCommand("copy"); // 执行copy事件，这时监听函数会执行save函数。
      document.removeEventListener("copy", save); // 移除copy事件
      // 保存方法
      function save(e) {
        e.clipboardData.setData("text/plain", val); // 剪贴板内容设置
        e.preventDefault();
      }
      this.$util.successMsg("地址已复制到剪切板");
    },
    // 推送认证信息给车主
    pushRz() {
      let _chatRecord = this.chatRecord;
      let _data = {
        content: "",
        type: 14,
        id: Math.random(),
        isRead: false
      };
      this.mapVisible = false;
      if (this.chatype == 1) {
        _chatRecord.push(_data);
        this.$util.sendSocket({
          cId: this.nowKhMsg.uId,
          SessionId: this.nowKhMsg.sessionId,
          contentType: 8,
          content: "车辆认证link"
        });
      } else {
        _chatRecord.push(_data);
        this.$util.sendLeaveMeg({
          cId: this.nowKhMsg.uId,
          SessionId: this.nowKhMsg.sessionId,
          contentType: 8,
          content: "车辆认证link"
        });
      }
    },
    // 清除地图数据
    clearMap() {
      this.locationMsg = "";
      this.mapVisible = false;
    },
    // 显示地图
    showMap(type, location) {
      if (type == 1) {
        this.locationMsg = location;
      } else {
        this.locationMsg = "";
      }
      this.mapVisible = true;
    },
    // 客服发送地理位置
    sendLocation(location) {
      let _chatRecord = this.chatRecord;
      let _data = {
        content: location,
        type: 13,
        id: Math.random(),
        isRead: false
      };
      this.mapVisible = false;
      _chatRecord.push(_data);
      if (this.chatype == 1) {
        this.$util.sendSocket({
          cId: this.nowKhMsg.uId,
          SessionId: this.nowKhMsg.sessionId,
          contentType: 9,
          content: location
        });
      } else {
        this.$util.sendLeaveMeg({
          cId: this.nowKhMsg.uId,
          SessionId: this.nowKhMsg.sessionId,
          contentType: 9,
          content: location
        });
      }
    },
    // 跳转商品详情
    gotoGoodsDetails(id) {
      this.$router.push(`/business/search/goodsDetail?id=${id}`);
    },
    //未使用
    clearNowKhMsg() {
      this.nowKhMsg = {};
    },
    // 显示大图
    showBig(event) {
      this.showBigSrc = event.target.currentSrc;
      this.showBigState = true;
    },
    // 企业客户端询问订单展开收起
    toggleOpen(state, index) {
      if (state == 1) {
        this.chatRecord[index].open = false;
      } else {
        this.chatRecord[index].open = true;
      }
    },
    // 标记已读
    markRead() {
      let _data = this.chatRecord;
      for (let i = 0; i < _data.length; i++) {
        _data[i].isRead = true;
      }
    },
    // 播放语音
    playVoice(item, index) {
      if (this.prevPlayIndex !== '') {
        this.chatRecord[this.prevPlayIndex].playing = false;
      }
      this.prevPlayIndex = index
      this.audioContext.src = this.downUrl + item.content;
      this.chatRecord[index].playing = true;
      this.audioContext.play();
    },
    // 停止聊天
    stopChat() {
      // if (this.nowKhMsg.sessionId) {
      //   this.$util.stopChat(this.nowKhMsg.sessionId).then(() => {
      //     //更新今日访客与对话列表
      //     this.$emit("uploadChatList", {});
      //   });
      // }
      this.$store.commit("updateCustomerMsg", {});
      this.historyPage = 1;
      this.chatRecord = [];
      this.nowKhMsg = {};
    },
    //未使用
    stopChatFromList(item) {
      if (item.uId == this.nowKhMsg.uId) {
        this.$store.commit("updateCustomerMsg", {});
      }
      this.historyPage = 1;
      this.chatRecord = [];
      this.nowKhMsg = {};
    },
    // 加载历史聊天记录
    loadHistoryChat() {
      this.historyPage += 1;
      this.GetNoRead(false);
    },
    // 接入客户的信息，未使用
    getkhMsg(data) {
      if (this.nowKhMsg.uId == data.uId) {
        return;
      }
      this.chatRecord = [];
      this.historyPage = 1;
      this.chatype = 1;
      this.nowKhMsg = data;
      this.GetNoRead();
    },
    // 给客户留言,拿到传递过来的留言人信息，未使用
    leaveWith(data) {
      if (this.nowKhMsg.uId == data.Id) {
        return;
      }
      this.chatRecord = [];
      this.historyPage = 1;
      this.chatype = 2;
      this.nowKhMsg = {
        avatarUrl: "",
        isJoin: false,
        isLeave: true,
        uId: data.Uid,
        uName: data.Name,
        uType: data.UType
      };
      this.GetNoRead();
    },
    // 返回信息处理
    OptResult(data) {
      // 留言失败
      if (data.code == 500) {
        this.$confirm(data.error, "提示", {
          confirmButtonText: "确定",
          showCancelButton: false,
          type: "warning"
        });
      }
    },
    // 选择顾客之前无法操作聊天区域
    cantWriteMsg() {
      this.$message({
        message: "未选择聊天对象",
        type: "warning"
      });
    },
    // 加载聊天历史
    GetNoRead(isScroll = true) {
      this.axios
        .get("/ChatCenter/GetMsgRecords", {
          params: {
            Type: "0", //查看人类型： 0 代表客服，1 代表客户
            CType: this.nowKhMsg.uType, //被看人类型：0车主；1企业客户
            CId: this.nowKhMsg.uId,
            SId: this.$store.state.userMsg.Id,
            page: this.historyPage,
            limit: 10
          }
        })
        .then(response => {
          let data = response.data.data.ContentList;
          let _chatRecord = this.chatRecord;
          if (!data || data.length == 0) {
            this.noMoreChat = true;
            return;
          }
          for (let i = 0; i < data.length; i++) {
            let isexist = false;
            //判断是否已经存在
            for (let index = 0; index < _chatRecord.length; index++) {
              if (_chatRecord[index].id == data[i].Id) {
                isexist = true;
                break;
              }
            }
            if (isexist) continue;
            let _data = {
              content: data[i].Content,
              type: -1,
              isRead: data[i].IsRead,
              id: data[i].Id,
              IsReciever: data[i].IsReciever
            };
            switch (data[i].ContentType) {
              // 文本(双向)
              case 0:
                // 客服发的
                if (data[i].IsReciever) {
                  _data.type = 1;
                }
                // 顾客发的
                else {
                  _data.type = 5;
                }
                break;
              //图片(双向)
              case 1:
                // 客服发的
                if (data[i].IsReciever) {
                  _data.type = 2;
                  _data.isHistory = true;
                }
                // 顾客发的
                else {
                  _data.type = 6;
                }
                break;
              //属性库商品
              case 2:
                // 客服
                if (data[i].IsReciever) {
                  _data.type = 4;
                } else {
                  _data.type = 8;
                }
                _data.content = JSON.parse(data[i].Content);
                _data.open = false;
                break;
              // 门店(单向 客服推给车主和商城)
              case 3:
                _data.type = 3;
                _data.content = JSON.parse(data[i].Content);
                break;
              // 客户语音(单向 小程序发给客服)
              case 4:
                _data.type = 7;
                _data.playing = false;
                break;
              // 临时商品 (单向 客服发给企业客户)
              case 5:
                _data.type = 10;
                _data.content = JSON.parse(data[i].Content);
                break;
              // 商城商品 （双向）
              case 6:
                // 客服
                if (data[i].IsReciever) {
                  _data.type = 11;
                } else {
                  _data.type = 8;
                }
                _data.content = JSON.parse(data[i].Content);
                _data.open = false;
                break;
              // 采购订单 （单向 企业客户发给客服）
              case 7:
                _data.type = 9;
                _data.content = JSON.parse(data[i].Content);
                break;
              // 车辆认证连接 （单向 客服发给车主）
              case 8:
                _data.type = 14;
                _data.content = data[i].Content;
                _data.open = false;
                break;
              // 位置 （双向）
              case 9:
                if (data[i].IsReciever) {
                  _data.type = 13;
                } else {
                  _data.type = 12;
                }
                _data.content = JSON.parse(data[i].Content);
                break;
              // 上门费用
              case 10:
                _data.type = 15;
                //在车主端确认费用时写入的是字符串，所以要先判断是不是Json的字符串
                //这只是简单判断，并非严谨的判断方式
                if(data[i].Content.indexOf('{')!=-1)
                  _data.content = JSON.parse(data[i].Content);

                break;
              case 11: //视频
                _data.type = 99;
                break;
              case 12://共享商品
              _data.content=JSON.parse(data[i].Content);
              _data.type = 8;
                break;   
              default:
                continue;
            }
            this.chatRecord.unshift(_data);
            if (isScroll) {
              this.$nextTick(() => {
                this.chatScrollToUnder();
              });
            }
          }
          if (data.length < 10) {
            this.noMoreChat = true;
            return;
          }
        })
        .catch(error => {
          console.log(error);
          this.$message.error("聊天历史获取失败！");
        });
    },
    //接收顾客发送的信息
    receiveChatMsg(message) {
      if (message.sender != this.nowKhMsg.uId) {
        return;
      }
      // 只要接收到了就告诉那边设为已读
      this.$util.markRead(
        this.nowKhMsg.uId,
        this.nowKhMsg.uType ? this.nowKhMsg.uType : 1
      );
      let _data = {};
      switch (message.contentType) {
        // 文字
        case 0:
          _data = {
            content: message.content,
            type: 5,
            id: message.id
          };
          break;
        // 图片
        case 1:
          _data = {
            content: message.content,
            type: 6,
            id: message.id
          };
          break;
        case 2:
          _data = {
            content: JSON.parse(message.content),
            type: 8,
            id: message.id
          };
          break;
        // 语音
        case 4:
          _data = {
            content: message.content,
            type: 7,
            playing: false,
            id: message.id
          };
          break;
        // 商城商品
        case 6:
          _data = {
            content: JSON.parse(message.content),
            type: 8,
            id: message.id
          };
          break;
        // B端推送过来的订单
        case 7:
          _data = {
            content: JSON.parse(message.content),
            type: 9,
            id: message.id,
            open: false
          };
          break;
        // 定位
        case 9:
          _data = {
            content: JSON.parse(message.content),
            type: 12,
            id: message.id,
            open: false
          };
          break;
        case 11: //视频
          _data = {
            content: message.content,
            type: 99,
            id: message.id
          };
          break;
        //共享商品
        case 12:
          _data = {
            content: JSON.parse(message.content),
            type: 8,
            id: message.id
          };
          break;
      }

      this.$set(_data, "IsReciever", false);
      this.$set(_data, "IsRead", true);

      this.showTime();
      this.chatRecord.push(_data);
      this.$nextTick(() => {
        this.chatScrollToUnder();
      });
    },
    // 接收在线的客服详情列表
    ReceiveOnLineServe(message) {
      let _data = message.content;
      for (let i = 0; i < _data.length; i++) {
        _data[i].active = false;
      }
      this.kfList = _data;
    },
    // 发送文字
    send() {
      if (this.inputValue == "") {
        return;
      }
      let _chatRecord = this.chatRecord;
      let _data = {
        content: this.inputValue,
        type: 1,
        id: Math.random(),
        isRead: false
      };
      this.showTime();
      _chatRecord.push(_data);
      this.$nextTick(() => {
        this.chatScrollToUnder();
      });
      // 发聊天消息
      if (this.chatype == 1) {
        this.$util.sendSocket({
          cId: this.nowKhMsg.uId,
          SessionId: this.nowKhMsg.sessionId,
          contentType: 0,
          content: this.inputValue
        });
      }
      // 留言
      else {
        this.$util.sendLeaveMeg({
          cId: this.nowKhMsg.uId,
          SessionId: this.nowKhMsg.sessionId,
          contentType: 0,
          content: this.inputValue
        });
      }

      // 发送后清空
      this.inputValue = "";
    },
    // 预览图片
    previewImage() {
      let that = this;
      let files = document.getElementById("chooseImgBtn").files;
      for (let i = 0; i < files.length; i++) {
        let reader = new FileReader();
        reader.onload = e => {
          let src = e.target.result;
          let _chatRecord = this.chatRecord;
          let _data = {
            content: src,
            type: 2,
            showLoading: true,
            id: Math.random(),
            isRead: false
          };
          this.showTime();
          _chatRecord.push(_data);
          this.$nextTick(() => {
            this.chatScrollToUnder();
          });
          this.nowLpLoadImgIndex = _chatRecord.length - 1;
          // 获取图片上传token
          let fileType = files[i].name
            .substr(files[i].name.lastIndexOf(".") + 1)
            .toLowerCase();
          this.$util.geToken("Chatting", fileType, false).then(data => {
            uploadFile({
              id: "chooseImgBtn", // 上传按钮id
              url: this.upUrl,
              maxSzie: 20 * 1024, // 文件最大大小，单位KB
              progressCtn: "", // 显示进度条的容器id，样式自己写
              nameMaxLen: 80, //名字最长字符数
              data: data,
              // 上传成功后执行
              success: function(res) {
                that.sendImgSocket(res.key);
              }
            });
          });
        };

        reader.readAsDataURL(files[i]);
      }
    },
    // 图片上传成功后要发websocket告诉服务端
    sendImgSocket(key) {
      let that = this;
      if (this.chatype == 1) {
        this.$util.sendSocket(
          {
            cId: this.nowKhMsg.uId,
            SessionId: this.nowKhMsg.sessionId,
            contentType: 1,
            content: key
          },
          function(res) {
            that.chatRecord[that.nowLpLoadImgIndex].id = res.data;
          }
        );
      } else {
        this.$util.sendLeaveMeg(
          {
            cId: this.nowKhMsg.uId,
            SessionId: this.nowKhMsg.sessionId,
            contentType: 1,
            content: key
          },
          function(res) {
            that.chatRecord[that.nowLpLoadImgIndex].id = res.data;
          }
        );
      }
      that.chatRecord[that.nowLpLoadImgIndex].showLoading = false;
      // 上传后要清空，否则上传相同图片时onchange不会触发
      document.getElementById("uploadForm").reset();
    },
    // 屏蔽访客
    showShield() {
      this.shieldVisible = true;
      this.shieldDaysChange();
    },
    shield() {
      if (!this.shieldData.BlockReason) {
        this.$util.warningMsg("请填写封锁原因");
        return;
      }
      this.shieldData.UType = this.nowKhMsg.uType ? this.nowKhMsg.uType : 0;
      this.shieldData.UId = this.nowKhMsg.uId;
      this.axios
        .post("/ChatCenter/BlockCustomer", this.shieldData)
        .then(response => {
          this.clientList = response.data.data;
          this.shieldVisible = false;
          this.$message({
            message: "屏蔽成功！",
            type: "success"
          });
        });
    },
    // 重置封锁表单
    resetShield() {
      this.shieldData = {
        UType: "",
        UId: "",
        IsPerpetualBlock: false, //是否永久封锁
        BlockReason: "", // 封锁原因
        UnBlockTime: ""
      };
      this.shieldVisible = false;
    },
    // 封锁天数变更
    shieldDaysChange(shieldDays = 1) {
      let date = new Date();
      date.setDate(date.getDate() + shieldDays);
      let result =
        date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
      this.shieldData.UnBlockTime = result;
    },
    // 发送图片
    uploadImg() {
      this.previewImage();
    },
    // 获取常用语
    getDailyWords(data) {
      this.inputValue += data;
    },
    // 选择表情包
    change(item) {
      this.inputValue += item;
      document.getElementById("input-box").focus();
      this.isEmotionShow = false;
    },
    //点击选择图片按钮
    chooseImg() {
      let btn = document.getElementById("chooseImgBtn");
      btn.click();
    },
    // 显示表情包
    showEmotion() {
      this.isEmotionShow = true;
    },
    // 显示推送门店弹窗
    showPush() {
      this.axios
        .get("/Common/LoadAutoRepairShops", {
          params: this.shopSearchData
        })
        .then(response => {
          let data = JSON.parse(response.data.data);
          this.mDList = data.data;
        })
        .catch(error => {
          console.log(error);
        });

      this.showPushShop = true;
    },
    // 推送门店
    pushShop(row) {
      let _chatRecord = this.chatRecord;
      let _data = {
        content: row,
        type: 3,
        id: Math.random(),
        isRead: false
      };
      this.showTime();
      _chatRecord.push(_data);
      this.$nextTick(() => {
        this.chatScrollToUnder();
      });
      if (this.chatype == 1) {
        this.$util.sendSocket({
          cId: this.nowKhMsg.uId,
          SessionId: this.nowKhMsg.sessionId,
          contentType: 3,
          content: JSON.stringify(row),
          ObjectId: row.Id
        });
      } else {
        this.$util.sendLeaveMeg({
          cId: this.nowKhMsg.uId,
          SessionId: this.nowKhMsg.sessionId,
          contentType: 3,
          content: JSON.stringify(row),
          ObjectId: row.Id
        });
      }
      this.showPushShop = false;
    },
    // 客服转接
    transfer() {
      // 请求其他在线客服
      this.$util.getOtherServes().then(data => {
        this.kfList = data.data;
      });
      this.showTransfer = true;
    },
    // 搜索其他客服
    searchOtherServes() {
      this.$util.getOtherServes(this.searchKfKey).then(data => {
        this.kfList = data.data;
      });
    },
    // 客服转接前点击客服先把他的信息存起来
    chooseKf(item, index) {
      this.kfListActive = index;
      this.transData.UId = this.nowKhMsg.uId;
      this.transData.UName = this.nowKhMsg.uName;
      this.transData.SId = this.$util.getSessionStorage("userMsg").Id;
      this.transData.ToSId = item.Id;
      this.transData.UserType = this.nowKhMsg.uType;
      this.transData.SessionId = this.nowKhMsg.sessionId;
      this.transData.referer = this.nowKhMsg.referer;
      this.transData.sessionType = this.nowKhMsg.sessionType;
      this.transData.ip = this.nowKhMsg.ip;
    },
    // 客服转接提交
    transferHandle(type) {
      if (type == 0) {
        this.showTransfer = false;
      } else {
        if (!this.transData.ToSId) {
          this.$util.warningMsg("未选择转接客服");
          return;
        }
        if (!this.transData.Reason) {
          this.$util.warningMsg("未填写转接原因");
          return;
        }
        let data = this.transData;
        this.axios
          .post("/ChatCenter/TransferCustomersToOthers", data)
          .then(response => {
            this.$util.successMsg("转接成功");
            //更新今日访客与对话列表
            this.$emit("uploadChatList", data);
          })
          .catch(error => {
            this.$message.error("转接失败！");
            console.log(error);
          });
        setTimeout(() => {
          this.showTransfer = false;
        }, 1000);
      }
    },
    // 两次消息之间相差指定时间要显示时间
    showTime() {
      let nowTimestamp = Date.parse(new Date());
      let _chatTimestamp = this.chatTimestamp;
      if (!_chatTimestamp) {
        this.chatTimestamp = nowTimestamp;
        let _data = {
          content: this.$util.getNowFormatTime(),
          type: -1,
          id: Math.random()
        };
        this.chatRecord.push(_data);
      } else {
        let chaMs = nowTimestamp - _chatTimestamp;
        let chaMin = chaMs / 1000 / 60;
        if (chaMin > 1) {
          let _data = {
            content: this.$util.getNowFormatTime(),
            type: -1,
            id: Math.random()
          };
          this.chatRecord.push(_data);
        }
      }
    },
    // 把聊天窗口滚动条滚到最下面
    chatScrollToUnder() {
      let ele = document.getElementById("chatContent");
      if (ele) {
        ele.scrollTop = ele.scrollHeight;
      }
    },
    //创建维修预约
    createRReservations(entpId) {
      this.$emit("createRReservations", this.nowKhMsg.uId, entpId);
    }
  }
};
</script>
<style lang="less" scoped>
.box-card {
  width: 300px;
}
.order-price {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.order-num {
  padding-bottom: 10px;
  margin-bottom: 10px;
  border-bottom: 1px solid @border3Color;
  > div:nth-child(1) {
    margin-bottom: 10px;
  }
}
.open-btn label {
  cursor: pointer;
  color: @theme;
}
.close-sate {
  max-height: 80px;
  overflow: hidden;
}
.order-state {
  color: @theme;
  cursor: pointer;
}
.no-read {
  color: @font4Color;
  font-size: 12px;
  margin-right: 5px;
}
.have-read {
  color: @font4Color;
  font-size: 12px;
  margin-right: 5px;
}
.no-more-chat {
  color: @font4Color;
  text-align: center;
  margin-bottom: 10px;
}
.show-more-chat {
  color: @theme;
  text-align: center;
  cursor: pointer;
  margin-bottom: 10px;
}
.emoji {
  position: absolute;
  bottom: 159px;
  left: 20px;
  width: 95%;
  z-index: 999;
  background: @border2Color;
  padding: 10px;
  border: 1px;
  border-radius: 10px;
}

.chat {
  position: relative;
  height: 100%;
}
.cover {
  display: flex;
  flex-direction: column;
  font-size: @font-lg;
  align-items: center;
  justify-content: center;
  background: @border4Color;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 99;
  img {
    margin-bottom: 20px;
  }
}
.chat-title {
  display: flex;
  align-items: center;
  padding: 10px 20px;
  background: @border4Color;
}

.chat-title-icon {
  font-size: @font-lg;
  margin-right: 20px;
}

.chat-title-main {
  line-height: 1.5em;
  display: flex;
}

.chat-content {
  position: absolute;
  width: 100%;
  height: calc(100% - 197px);
  top: 41px;
  left: 0;
  right: 0;
  bottom: 30px;
  padding: 10px 20px 0;
  overflow: auto;
}

.chat-input {
  position: absolute;
  width: 100%;
  height: 156px;
  left: 0;
  bottom: 0;
  border-top: 1px solid @border1Color;
}

.chat-options {
  display: flex;
  align-items: center;
  height: 30px;
  padding: 0 20px;
  background: @border4Color;
  img {
    width: 16px;
    height: 16px;
    margin-right: 20px;
    cursor: pointer;
  }
}

.input-box {
  position: absolute;
  width: 100%;
  height: calc(100% - 70px);
  top: 30px;
  left: 0;
  right: 0;
  bottom: 30px;
  overflow: auto;
  box-sizing: border-box;
  resize: none;
  border: none;
}

.send-ctn {
  position: absolute;
  width: 100%;
  height: 39px;
  left: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-right: 10px;
  border-top: 1px solid @border2Color;
}

.transfer-search {
}

.search-input {
  width: 50%;
}

.transfer-content {
  .main-ctn {
    display: flex;
    justify-content: space-between;
    > div {
      width: 49%;
      border-radius: 5px;
    }
  }
}

.kf-list {
  border: 1px solid @border4Color;
  height: 350px;
  overflow: auto;
}
.trans-reason {
  border: 1px solid @border4Color;
  height: 250px;
  overflow: auto;
}
.main-ctn-title {
  font-size: @font-sm;
  padding: 10px 0;
}
.is-required:before{
      content: "*";
      color: #f56c6c;
      margin-right: 4px;
  }

.kf-item {
  display: flex;
  height: 56px;
  padding-left: 20px;
  align-items: center;
  cursor: pointer;
  &:hover {
    background: @border4Color;
  }
  img {
    width: 20px;
    height: 20px;
    margin-right: 10px;
  }
  .kf-name {
    display: inline-block;
    width: 80px;
  }
  .kf-remark {
  }
}

.trans-reason {
  textarea {
    width: 100%;
    height: 100%;
    resize: none;
    border: none;
    padding: 10px;
  }
}

.emoji-item {
  display: inline-block;
  width: 30px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  cursor: pointer;
  margin-bottom: 5px;
}

/***************************/
.chat-time {
  width: 100%;
  text-align: center;
  font-size: @font-xxs;
  color: @font2Color;
  padding-bottom: 10px;
}
.iSay {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.cha-content {
  margin-bottom: 15px;
  position: relative;
}

.my-head {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  border: 2px solid @border4Color;
}

.myContent {
  line-height: 1.2em;
  margin-right: 10px;
  background: @theme;
  color: white;
  border-radius: 5px;
  padding: 12px 10px;
  position: relative;
  max-width: 300px;
  display: flex;
  align-items: center;

  &:after {
    display: block;
    content: "";
    border-width: 8px 8px 8px 8px;
    border-style: solid;
    border-color: transparent transparent transparent @theme;

    /* 定位 */
    position: absolute;
    right: -16px;
    top: 50%;
    transform: translate(0, -50%);
  }
}
.otherSay {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.otherContent {
  line-height: 1.2em;
  margin-left: 10px;
  background: @theme;
  color: white;
  border-radius: 5px;
  padding: 12px 10px;
  position: relative;
  max-width: 300px;
  display: flex;
  align-items: center;
}
.otherContent::after {
  display: block;
  content: "";
  border-width: 8px 8px 8px 8px;
  border-style: solid;
  border-color: transparent @theme transparent transparent;
  /* 定位 */
  position: absolute;
  left: -16px;
  top: 50%;
  transform: translate(0, -50%);
}
.emoji-item {
  font-size: 20px;
  cursor: pointer;
}
.iSayImage {
  display: flex;
  align-items: flex-start;
  .image-ctn {
    display: flex;
    align-items: center;
    margin-right: 20px;
    img {
      width: 200px;
      height: auto;
      border: 1px solid @border4Color;
      margin-left: 10px;
    }
  }
}
.otherSay {
  display: flex;
  align-items: flex-start;
  .image-ctn {
    display: flex;
    align-items: center;
    margin-left: 20px;
    img {
      width: 200px;
      height: auto;
      border: 1px solid @border4Color;
      margin-right: 10px;
    }
  }
}
.kf-active {
  background: @border4Color;
}
.order-item-ctn {
  margin-bottom: 20px;
  cursor: pointer;
  width: 300px;
}

.order-item {
  display: flex;
  .order-cover {
    width: 70px;
    height: 50px;
    margin-right: 10px;
  }
  .order-name {
    font-size: @font-sm;
    margin-bottom: 10px;
  }
}
.iPushShop {
  display: flex;
  align-items: flex-start;
}
.chat-voice-icon {
  height: 14px;
  margin: 0 20px 0 5px;
}
.voice-ctn {
  cursor: pointer;
}
.chat-image {
  cursor: pointer;
}
</style>
